'use client'

/* eslint-disable @next/next/no-img-element */
import React from 'react'
import classNames from 'classnames'
import Image from 'next/image'
import { useParams } from 'next/navigation'
import Link from 'next/link'
import eventPageStyles from '@/styles/pages/EventsPage.module.css'
import styles from '@/app/_components/EventBackButton/EventBackButton.module.css'
import { EVENTS_SLUG_POSTFIX } from '@/config/navigation.config'
import TXT from '@/messages'

type Props = {
  isCheckout?: boolean
}
const EventBackButton: React.FunctionComponent<Props> = ({ isCheckout = false }: Props) => {
  const { sellerSlug } = useParams<{ sellerSlug: string }>()

  return (
    <div
      className={classNames(
        styles.BackButtonContainer,
        'event-details',
        { [styles.Checkout]: isCheckout },
      )}
      data-testid="event-back-button-container"
    >
      <div
        className={classNames(
          eventPageStyles.HeaderBg,
          styles.BackButton,
        )}
      >
        <Link
          className={styles.BackButtonLink}
          href={`/${sellerSlug}/${EVENTS_SLUG_POSTFIX}/`}
          data-testid="back-button-top"
          aria-label={TXT.eventsA11y.backToEventsList}
          scroll={false}
        >
          <Image height={24} width={24} src="/static/events/svg/back.svg" className="back-arrow" alt={TXT.eventsA11y.goBack} />
          {TXT.buttons.backToEvents}
        </Link>
      </div>
      <div className={classNames(eventPageStyles.SwoopTop, styles.SwoopTop)}>
        <img
          src="/static/events/svg/event-details-top.svg"
          alt={TXT.eventsA11y.heroDivider}
          aria-hidden="true"
          tabIndex={-1}
        />
      </div>
    </div>
  )
}

export default EventBackButton
